import { CancelToken } from 'axios';
import qs from 'querystring';

import StandardGateway from './lib/standard_gateway';

export default class LiveboardGateway extends StandardGateway {
  constructor(backend) {
    super(backend, 'v1/orgs/:orgId/liveboards/:type');
  }

  fetchAgentsLiveboard(query, config = {}) {
    return this.fetch('agents', query, config);
  }

  fetchSummaryLiveboard(query, config = {}) {
    return this.fetch('summary', query, config);
  }

  fetchTopicsLiveboard(query, config = {}) {
    return this.fetch('topics', query, config);
  }

  fetch(type, query, config) {
    this.source = CancelToken.source();
    config.cancelToken = this.source.token;

    return this.http.get(requestUrl(this.endpoint.set({ type }).fetchUrl, query), config);
  }

  cancelOutstandingRequest() {
    this.source && this.source.cancel();
  }
}

function requestUrl(url, params) {
  let query = qs.stringify(params);
  return `${url}?${query}`;
}



// WEBPACK FOOTER //
// ./src/scripts/adapters/gateways/liveboard_gateway.js